<template>
  <div class="container" :style="backgroundStyleComputed">
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script setup>
import { getZoneList } from '@/api/common';
import { ref, computed, onMounted, watchEffect } from 'vue';
import Header from "@/components/Header";
import Footer from '@/components/Footer'
import { useRoute } from "vue-router";
const $route = useRoute();
import { useStore } from 'vuex'
const store = useStore()
import { emitter } from '@/utils/eventBus';

const backgroundStyle = ref({});
const initZoneList = async () => {
  try {
    const res = await getZoneList();
    if (res.errno === 0) {
      const defaultBackground = res.data.list.find(item => item.isDefault);
      if (defaultBackground) {
        const backgroundImageUrl = defaultBackground.img;
        const backgroundRepeat = defaultBackground.composing ? 'repeat' : 'no-repeat';
        let backgroundPosition;
        switch (defaultBackground.align) {
          case 0:
            backgroundPosition = 'top center';
            break;
          case 1:
            backgroundPosition = 'left top';
            break;
          default:
            backgroundPosition = 'right top';
        }
        backgroundStyle.value = {
          backgroundImage: `url(${backgroundImageUrl})`,
          backgroundRepeat,
          backgroundPosition
        };
      }
    } else {
      message.error(res.errmsg);
    }
  } catch (error) {
    console.error("出现异常：", error);
  }
};

const backgroundStyleComputed = computed(() => backgroundStyle.value);
const getOtherData = async () => {
  const hisUid = $route.query.hisUid;
  if (hisUid) {
    await store.dispatch('other/fetchData', { hisUid });
    emitter.emit('otherInfoFetched'); // 数据获取成功后发送事件通知其他组件
    const defaultBackground = store.state.other.otherInfo.ZoneInfo;
    if (defaultBackground) {
      const backgroundImageUrl = defaultBackground.img;
      const backgroundRepeat = defaultBackground.composing ? 'repeat' : 'no-repeat';
      let backgroundPosition;
      switch (defaultBackground.align) {
        case 0:
          backgroundPosition = 'top center';
          break;
        case 1:
          backgroundPosition = 'left top';
          break;
        default:
          backgroundPosition = 'right top';
      }
      backgroundStyle.value = {
        backgroundImage: `url(${backgroundImageUrl})`,
        backgroundRepeat,
        backgroundPosition
      };
    }
  }
};

onMounted(() => {
  if (!$route.query.hisUid) {
    initZoneList()
  } else {
    getOtherData()
  }
})

watchEffect(() => {
  const hisUid = $route.query.hisUid;
  if (hisUid !== undefined) {
    getOtherData();
  }
});
</script>

<style lang="scss" scoped>
.container {
  min-height: calc(100vh - 254px);
}
</style>
